import axios from "axios";

// default
axios.defaults.baseURL = "https://api.autodijelovisefer.com/";  // Production

//axios.defaults.baseURL = "https://testapi.autodijelovisefer.com/";  // Test
//axios.defaults.baseURL = "http://localhost:5000/";  // Local development
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

const token = JSON.parse(sessionStorage.getItem("authUser")) ? JSON.parse(sessionStorage.getItem("authUser")).token : null;
if(token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) return null;
  return JSON.parse(user);  
};

class APIClient {
  
  get = (url, params) => {
    let response;
    let paramKeys = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }
    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    let response = axios.post(url, data);
    return response;
  };

  createForm = (url, data) => {
    let response = axios.postForm(url, data);
    return response;
  };

  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };

  updateForm = (url, data) => {
    return axios.patchForm(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, data) => {
    return axios.update(url, data);
  };

  deleteCustom = (url) => axios.delete(url);

}

export { APIClient, setAuthorization, getLoggedinUser };